import React from 'react';
import LzXLayoutBase from './LayoutBase/component';
import LzXDiv from '../commons/Div';
import LzXContainer from '../commons/Container';

export interface LzPLayoutPublic {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  bgImg?: string;
  noContainer?: boolean;
}

export default function LzXLayoutPublic(props: LzPLayoutPublic) {
  // Apply wrapper based on container existance
  const WrapperComponent = props.noContainer ? LzXDiv : LzXContainer;

  // Now show the public layout using the wrapper above
  return (
    <LzXLayoutBase bgImg={props.bgImg}>
      <WrapperComponent
        className={'lz-layout-public ' + (props.className || '')}
        style={props.style}
      >
        {props.children}
      </WrapperComponent>
    </LzXLayoutBase>
  );
}
